import { httpClientService } from '../settingsApi/httpClientService';

export type SycurioEventType =
  | 'startSycurio'
  | 'onDone'
  | 'onDelete';

export default async function commonSycurioTelephonicEntryService({
  checkoutSessionId,
  method = 'post',
  eventType,
}: {
  checkoutSessionId: string;
  method?: Methods;
  eventType: SycurioEventType;
}) {
  let data:
    | Record<'context', 'PAYMENT_METHOD_TOKENIZED' | 'CANCELLED'>
    | undefined;
  if (['onDelete'].includes(eventType)) {
    data = {
      context: 'CANCELLED',
    };
  }
  if (eventType === 'onDone') {
    data = {
      context: 'PAYMENT_METHOD_TOKENIZED',
    };
  }

  const httpClient = httpClientService.getHttpClient({
    api: 'WALLET',
  });

  const resolvedMethod: Methods =
    eventType === 'onDone' || eventType === 'onDelete'
      ? 'delete'
      : method;

  return httpClient.request<{ requestId: string }>({
    url: `/checkout-sessions/${checkoutSessionId}/telephonic-entry`,
    method: resolvedMethod,
    data,
  });
}
